import { apiClient } from './client';
import type {
  AdminLoginRequest,
  LoginResult,
  Admin2FAVerifyRequest,
  AdminLoginResponse,
  Admin2FASetupResponse,
  Admin2FASetupConfirmRequest,
  AdminSessionListResponse,
} from '../types/auth';
import type { MessageResponse } from '../types/api';

export const authApi = {
  login: (data: AdminLoginRequest) =>
    apiClient.post<LoginResult>('/auth/login', data).then((r) => r.data),

  verify2fa: (data: Admin2FAVerifyRequest) =>
    apiClient.post<AdminLoginResponse>('/auth/verify-2fa', data).then((r) => r.data),

  setup2fa: () =>
    apiClient.post<Admin2FASetupResponse>('/auth/setup-2fa').then((r) => r.data),

  confirm2fa: (data: Admin2FASetupConfirmRequest) =>
    apiClient.post<MessageResponse>('/auth/confirm-2fa', data).then((r) => r.data),

  logout: () =>
    apiClient.post<MessageResponse>('/auth/logout').then((r) => r.data),

  getSessions: () =>
    apiClient.get<AdminSessionListResponse>('/auth/sessions').then((r) => r.data),

  revokeSession: (sessionId: string) =>
    apiClient.delete<MessageResponse>(`/auth/sessions/${sessionId}`).then((r) => r.data),
};
